module.exports = __webpack_public_path__ + "static/media/Download-image.723d4a90.svg";